export default __webpack_public_path__ + "973dcf7a51416b88c6f1c35786178ef1.svg";